import React from "react";

const InvoiceFilters = ({ filters, onFilterChange, onClear }) => {
  return (
    <div className="containerInput">
      <div className="w-[100%]  flex items-center justify-center">
        <button
          className="px-4 my-3 py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
          onClick={onClear}
        >
          مسح
        </button>
      </div>

      <div className="input-group">
        <label>
          الكود
          <input
            type="text"
            name="code"
            value={filters.code}
            onChange={onFilterChange}
            placeholder="مثال: 253861-252600"
          />
          <span className="block text-xs text-gray-500 mt-1">يمكنك إدخال أكثر من كود مفصولين بعلامة -</span>
        </label>
        <label>
          التاريخ
          <input
            type="date"
            name="date"
            value={filters.date}
            onChange={onFilterChange}
          />
        </label>
        <label>
          العميل
          <input
            type="text"
            name="client"
            value={filters.client}
            onChange={onFilterChange}
            placeholder="العميل"
          />
        </label>
        <label>
          التليفون
          <input
            type="text"
            name="phone"
            value={filters.phone}
            onChange={onFilterChange}
            placeholder="التليفون"
          />
        </label>
        <label>
          العنوان
          <input
            type="text"
            name="address"
            value={filters.address}
            onChange={onFilterChange}
            placeholder="العنوان"
          />
        </label>
      </div>

      <div className="input-group">
        <label>
          المستخدم
          <input
            type="text"
            name="user"
            value={filters.user}
            onChange={onFilterChange}
            placeholder="المستخدم"
          />
        </label>
        <label>
          المندوب
          <input
            type="text"
            name="representative"
            value={filters.representative}
            onChange={onFilterChange}
            placeholder="المندوب"
          />
        </label>
        <label>
          الحالة
          <input
            type="text"
            name="status"
            value={filters.status}
            onChange={onFilterChange}
            placeholder="الحالة"
          />
        </label>
        <label>
          الكمية
          <input
            type="number"
            name="quantity"
            value={filters.quantity}
            onChange={onFilterChange}
            placeholder="الكميه"
          />
        </label>
        <label>
          المحافظه
          <input
            type="text"
            name="governorate"
            value={filters.governorate}
            onChange={onFilterChange}
            placeholder="المحافظه"
          />
        </label>
      </div>
    </div>
  );
};

export default InvoiceFilters; 